import { render, staticRenderFns } from "./kitchen-code.vue?vue&type=template&id=3d57325d&scoped=true&"
import script from "./kitchen-code.vue?vue&type=script&lang=ts&"
export * from "./kitchen-code.vue?vue&type=script&lang=ts&"
import style0 from "./kitchen-code.vue?vue&type=style&index=0&id=3d57325d&prod&lang=scss&"
import style1 from "./kitchen-code.vue?vue&type=style&index=1&id=3d57325d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57325d",
  null
  
)

export default component.exports